export default "__VITE_ASSET__DxDdPmwZ__"